/**
 * Lesson note endpoints.
 */
import type { NoteItem, NotesListResponse } from '@/types/api';
import { apiClient } from './client';

/**
 * Notes API endpoints
 */
export const notesApi = {
  /** Create a new note for a lesson */
  createNote: (
    lessonId: string,
    data: { title?: string; content?: string; section_id?: string }
  ) => apiClient.post<NoteItem>(`/lessons/${lessonId}/notes`, data),

  /** List notes for a lesson */
  listNotes: (lessonId: string) =>
    apiClient.get<NotesListResponse>(`/lessons/${lessonId}/notes`),

  /** Get a single note */
  getNote: (noteId: string) => apiClient.get<NoteItem>(`/notes/${noteId}`),

  /** Update a note */
  updateNote: (
    noteId: string,
    data: { title?: string; content?: string; section_id?: string }
  ) => apiClient.put<NoteItem>(`/notes/${noteId}`, data),

  /** Delete a note */
  deleteNote: (noteId: string) => apiClient.delete(`/notes/${noteId}`),

  /** Get all notes across lessons (paginated, searchable) */
  getAllNotes: (params?: {
    search?: string;
    page?: number;
    limit?: number;
  }) => {
    const query = new URLSearchParams();
    if (params?.search) query.append('search', params.search);
    if (params?.page) query.append('page', params.page.toString());
    if (params?.limit) query.append('limit', params.limit.toString());
    const queryString = query.toString();
    const endpoint = queryString
      ? `/users/me/notes?${queryString}`
      : '/users/me/notes';
    return apiClient.get<NotesListResponse>(endpoint);
  },
};
